<template>
  <am2-card-container
    :class="[
      'ar-simple-card-skeleton',
      showAs,
    ]"
  >
    <ar-skeleton class="left-section" :level="level" />
    <div class="right-section">
      <am2-typography-skeleton
        class="text-skeleton upper"
        size="sm"
        :level="level + 2"
        :style="{
          maxWidth: '200px',
        }"
      />
      <am2-typography-skeleton
        class="text-skeleton lower"
        size="xs"
        :level="level + 2"
        :style="{
          maxWidth: '250px',
        }"
      />
    </div>
  </am2-card-container>
</template>

<script>
export default {
  name: 'SimpleCardSkeleton',

  props: {
    showAs: {
      type: String,
      default: 'list',
      validator: (value) =>
        ['list', 'tiles'].indexOf(value) !== -1,
    },
    level: {
      type: Number,
      default: 1,
      validator: (val) => val > 0,
    },
  },
};
</script>

<style lang="scss" scoped>
.ar-simple-card-skeleton {
  display: flex;
  padding: 20px 22px;

  .left-section {
    border-radius: 5px;
  }

  .right-section {
    display: flex;
    flex-flow: column;
    padding-left: 20px;
  }

  &.list {
    flex-flow: row;
    align-items: center;

    .left-section {
      width: 74px;
      height: 50px;
    }

    .right-section {
      justify-content: space-between;
      .text-skeleton {
        height: 20px;

        &.upper {
          width: 200px;
        }

        &.lower {
          width: 250px;
          height: 16px;
          margin-top: 8px;
        }
      }
    }
  }
  &.tiles {
    flex-flow: column;
    align-items: center;
    justify-content: center;

    .left-section {
      width: 62px;
      height: 62px;
      margin-bottom:24px;
      border-radius: 50%;
      position:relative;
      top: -52px;
      background-color: $skyBlueGrey400;
    }

    .right-section {
      margin-top: 8px;
      padding: 0;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      position: relative;
      top: -30px;

      .text-skeleton {
        height: 20px;

        &.upper {
          width: calc(100% - 50px);
          position: relative;
          top: -10px;
        }

        &.lower {
          width: 100%;
          margin-top: 8px;
          position: relative;
          top: 10px;
        }
      }
    }
  }
}
</style>
